'use strict';

module.exports = {
    min: 'zmin',
    max: 'zmax'
};
